module.exports = __webpack_public_path__ + "static/media/03_reflections-burnaby.9505a40c.jpg";